/**
 * 所属組織へのアクセス権がない場合の 403 エラー。
 * バックエンドが code: "NO_ORGANIZATION_ACCESS" を返す。
 * フロント側は GET /v2/me/memberships で有効な組織一覧を取得し、
 * PATCH /v2/me/organization で切り替える。
 */
export class NoOrganizationAccessError extends Error {
  constructor(message = 'No organization access') {
    super(message);
    this.name = 'NoOrganizationAccessError';
    Object.setPrototypeOf(this, NoOrganizationAccessError.prototype);
  }
}